import React from 'react';

import TagAdd from 'src/Components/Tag/TagAdd';
import TagsList from 'src/Components/Tag/TagsList';

function TagsView({ ...rest }) {
  return (
    <div {...rest}>
      <h1>Tags</h1>
      <TagAdd />
      <br />
      <TagsList />
    </div>
  );
}

export default TagsView;
